import React from "react";
import { connect } from "react-redux";
import "rc-slider/assets/index.css";
import { Input, Row, Col, Label, InputGroup } from "reactstrap";

import { formActions } from "../../../../../store/actions/cms/form/form.action";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import CondtionTypeList from "../../../../areas/form/conditions/components/CondtionTypeList";
import { deepClone } from "../../../../../helpers/objectHelper";
import ColorPickerFacade from "../../../../../components/UI/Buttons/ColorPickerFacade";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import { sourceTypes } from "../../../../../constants/cms/sourceType";
import { pageActions } from "../../../../../store/actions/cms/page/page.action";
import { templateHelper } from "../../../../areas/template/helpers/templateHelper";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { UrlMultiInput } from "../../../../components/editor/tools/UrlMultiInput/UrlMultiInput";
import EditorSlider from "../../../../components/editor/tools/EditorSlider";
import JirangoSwitch from "../../../../../components/UI/Switch/JirangoSwitch";
import Select from "react-select";
import { defaultEventGroupProps } from "../../../../models/eventGroup";
import { elementConstants } from "../../../../../constants/cms/form/element/element.constants";

const containerTypes = [
  { value: "DEFAULT", label: <SystemLabel name="Default" /> },
  { value: "EVENT_GROUP", label: <SystemLabel name="EventGroup" /> },
];

class ContainerSettings extends React.Component {
  state = { isMediaVaultOpen: false };
  handleSoftUpdate = (element) => {
    const { dispatch, cms, page } = this.props;
    const { enviroment } = cms;
    if (enviroment === sourceTypes.FORM) dispatch(formActions.updateFormElement(element));
    if (enviroment === sourceTypes.PAGE) dispatch(pageActions.updatePageElement(element, null, page));
    if (enviroment === sourceTypes.TEMPLATE) {
      const template = deepClone(this.props.template);
      const newTemplate = templateHelper.handleElementUpdates(element, template);
      dispatch(templateActions.softUpdate(newTemplate));
    }
  };

  parseColorToRgba = (color) => {
    const { r, g, b, a } = color.rgb;
    return `rgba(${r},${g},${b},${a})`;
  };
  toggleEventGroup = (groupId, off = false) => {
    if (off) {
      const events = this.props.form.formElements.filter((fe) => {
        return fe.type === elementConstants.EVENT && fe.data.groupId === groupId;
      });
      if (events.length > 0) {
        events.map((e) => {
          let element = deepClone(e);
          element.data.groupId = -1;
          this.handleSoftUpdate(element);
        });
      }
    } else {
      const mainContainersChildrens = this.props.form.formElements
        .filter((fe) => {
          return fe.type === elementConstants.CONTAINER && fe.parentId === groupId;
        })
        .map((cc) => {
          return cc.id;
        });

      const events = this.props.form.formElements.filter((fe) => {
        return fe.type === elementConstants.EVENT && fe.parentId !== null;
      });
      if (events.length > 0) {
        events.map((e) => {
          if (mainContainersChildrens.includes(e.parentId)) {
            let element = deepClone(e);
            element.data.groupId = groupId;
            this.handleSoftUpdate(element);
          }
        });
      }
    }
  };
  handleChange = (color, val, path) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedContainer);
    let value = color ? this.parseColorToRgba(color) : val;
    if (path === "data.type") {
      if (val === "DEFAULT") {
        element.data.extra = null;
        this.toggleEventGroup(element.id, true);
      } else if (val === "EVENT_GROUP") {
        element.data.extra = defaultEventGroupProps;
        this.toggleEventGroup(element.id, false);
      }
      element[names[0]][names[1]] = value;
    } else if (names.length === 2) {
      element[names[0]][names[1]] = value;
    } else if (names.length === 3) {
      element[names[0]][names[1]][names[2]] = value;
    } else if (names.length === 4) {
      element[names[0]][names[1]][names[2]][names[3]] = value;
    }
    this.handleSoftUpdate(element);
  };
  setBackgroundImage = (url) => {
    const element = deepClone(this.props.selectedContainer);
    element.data.backgroundUrl = url;
    element.data.background = `url('${url}')  no-repeat center center / cover`;
    this.handleSoftUpdate(element);
  };
  toggleMediaVault = () => {
    this.setState({ isMediaVaultOpen: !this.state.isMediaVaultOpen });
  };
  handleSpaceOnChange = (e, path, dir) => {
    const names = path.split(".");
    const element = deepClone(this.props.selectedContainer);
    const spaceValue = element[names[0]][names[1]];
    let value = e.target.value;
    let splitted = spaceValue.toString().split(" ");
    if (splitted.length > 1) {
      splitted[dir] = value + "px";
      splitted = splitted.join(" ");
      element[names[0]][names[1]] = splitted;
    } else {
      let newString = `${splitted[0]}px ${splitted[0]}px ${splitted[0]}px ${splitted[0]}px`;
      newString = newString.split(" ");
      newString[dir] = value + "px";

      element[names[0]][names[1]] = newString.join(" ");
    }
    this.handleSoftUpdate(element);
  };
  convertSpaceValue = (value, index) => {
    let splitted = value.toString().split(" ");
    if (splitted.length > 1) {
      return parseInt(splitted[index]);
    } else {
      return parseInt(splitted[0]);
    }
  };
  handleUnitChange = (unit, path) => {
    const element = deepClone(this.props.selectedContainer);

    const names = path.split(".");

    element[names[0]][names[1]][names[2]] = parseFloat(element[names[0]][names[1]][names[2]]) + unit;

    this.handleSoftUpdate(element);
  };
  render() {
    const { selectedContainer, cms } = this.props;
    if (selectedContainer === null) return null;
    return (
      <div>
        <ListExpansion footer={false} icon="fa fa-sticky-note" description="ContainerSettings" defaultExpanded={true}>
          {cms.enviroment === sourceTypes.FORM ? (
            <React.Fragment>
              <Row>
                <Col className="list-setting-item-title">
                  <Label>
                    <SystemLabel name="ContainerType" />
                  </Label>
                </Col>
                <Col className="list-setting-item-input">
                  <Select
                    classNamePrefix="jirango-select"
                    className="jirango-select"
                    options={containerTypes.map((t) => {
                      return { value: t.value, label: t.label };
                    })}
                    value={containerTypes.find((t) => {
                      return t.value === selectedContainer.data.type;
                    })}
                    onChange={(selectedOption) => this.handleChange(null, selectedOption.value, "data.type")}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: "0px" }}>
                <Col className="list-setting-item-title">
                  <p className="text-muted" style={{ lineHeight: "initial", marginTop: "0px" }}>
                    <SystemLabel name="ContainerTypeInfo" />
                  </p>
                </Col>
              </Row>
            </React.Fragment>
          ) : null}

          {selectedContainer.data.type === "EVENT_GROUP" ? (
            <React.Fragment>
              <br />
              <Row>
                <Col className="list-setting-item-title">
                  <Label>
                    <SystemLabel name="RequiredMin" tagName="label" />
                  </Label>
                </Col>
                <Col className="list-setting-item-input">
                  <InputGroup className="mb-3">
                    <Input type="number" min={0} value={selectedContainer.data.extra.min} onChange={(e) => this.handleChange(null, e.target.value, `data.extra.min`)} />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="list-setting-item-title">
                  <Label>
                    {" "}
                    <SystemLabel name="RequiredMax" tagName="label" />
                  </Label>
                </Col>
                <Col className="list-setting-item-input">
                  <InputGroup className="mb-3">
                    <Input type="number" min={0} value={selectedContainer.data.extra.max} onChange={(e) => this.handleChange(null, e.target.value, `data.extra.max`)} />
                  </InputGroup>
                </Col>
              </Row>
              <Row>
                <Col className="list-setting-item-title">
                  <Label>
                    <SystemLabel name="ValidationMessage" />
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col className="list-setting-item-title">
                  <Input
                    autoComplete="jirango-nofill"
                    type="textarea"
                    style={{ resize: "none", minHeight: "100px" }}
                    value={selectedContainer.data.validation.message}
                    onChange={(e) => this.handleChange(null, e.target.value, `data.validation.message`)}
                  />
                </Col>
              </Row>
            </React.Fragment>
          ) : null}

          <hr />
          {selectedContainer.data.padding !== undefined ? (
            <React.Fragment>
              <Row>
                <Col className="list-setting-item-title">
                  <Label>
                    <SystemLabel name="Padding" />
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col className="list-setting-item-title" style={{ display: "inline-flex" }}>
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={(e) => this.handleSpaceOnChange(e, `data.padding`, 0)}
                      value={this.convertSpaceValue(selectedContainer.data.padding, 0)}
                    />
                    <em>
                      <p style={{ textAlign: "center" }} className="text-muted">
                        <SystemLabel name="Top" />
                      </p>
                    </em>
                  </div>
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={(e) => this.handleSpaceOnChange(e, `data.padding`, 1)}
                      value={this.convertSpaceValue(selectedContainer.data.padding, 1)}
                    />
                    <em>
                      <p style={{ textAlign: "center" }} className="text-muted">
                        <SystemLabel name="Right" />
                      </p>
                    </em>
                  </div>
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={(e) => this.handleSpaceOnChange(e, `data.padding`, 2)}
                      value={this.convertSpaceValue(selectedContainer.data.padding, 2)}
                    />
                    <em>
                      <p style={{ textAlign: "center" }} className="text-muted">
                        <SystemLabel name="Bottom" />
                      </p>
                    </em>
                  </div>
                  <div>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      onChange={(e) => this.handleSpaceOnChange(e, `data.padding`, 3)}
                      value={this.convertSpaceValue(selectedContainer.data.padding, 3)}
                    />
                    <em>
                      <p style={{ textAlign: "center" }} className="text-muted">
                        <SystemLabel name="Left" />
                      </p>
                    </em>
                  </div>
                </Col>
              </Row>
              {/*  <Row>
                <Col className="list-setting-item-title">
                  <em>
                    <p className="text-muted">
                      <SystemLabel name="SpaceDirections" />
                    </p>
                  </em>
                </Col>
              </Row> */}
              <hr />
              {selectedContainer.data.margin !== undefined ? (
                <React.Fragment>
                  <Row>
                    <Col className="list-setting-item-title">
                      <Label>
                        <SystemLabel name="Margin" />
                      </Label>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="list-setting-item-title" style={{ display: "inline-flex" }}>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.margin`, 0)}
                          value={this.convertSpaceValue(selectedContainer.data.margin, 0)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Top" />
                          </p>
                        </em>
                      </div>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.margin`, 1)}
                          value={this.convertSpaceValue(selectedContainer.data.margin, 1)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Right" />
                          </p>
                        </em>
                      </div>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.margin`, 2)}
                          value={this.convertSpaceValue(selectedContainer.data.margin, 2)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Bottom" />
                          </p>
                        </em>
                      </div>
                      <div>
                        <Input
                          autoComplete="jirango-nofill"
                          type="number"
                          onChange={(e) => this.handleSpaceOnChange(e, `data.margin`, 3)}
                          value={this.convertSpaceValue(selectedContainer.data.margin, 3)}
                        />
                        <em>
                          <p style={{ textAlign: "center" }} className="text-muted">
                            <SystemLabel name="Left" />
                          </p>
                        </em>
                      </div>
                    </Col>
                  </Row>
                  {/*  <Row>
                <Col className="list-setting-item-title">
                  <em>
                    <p className="text-muted">
                      <SystemLabel name="SpaceDirections" />
                    </p>
                  </em>
                </Col>
              </Row> */}
                  <hr />
                </React.Fragment>
              ) : null}
              <hr />
            </React.Fragment>
          ) : null}
          {/*   <SpaceSettings
            onChange={this.handleChange}
            path="data.padding"
            label="Padding"
            val={selectedContainer.data.padding}
          /> */}
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="BackgroundColor" />
              </Label>
            </Col>
            <Col className="list-setting-item-input">
              <ColorPickerFacade color={selectedContainer.data.background} onChange={(color, e) => this.handleChange(color, e, "data.background")} path="data.background" />
            </Col>
          </Row>
          <br />
          <UrlMultiInput margin={false} onChange={this.setBackgroundImage} url={selectedContainer.data.backgroundUrl} />
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="FixateBackground" />
              </Label>
            </Col>
            <Col className="list-setting-item-input" style={{ textAlign: "right" }}>
              <JirangoSwitch
                onChange={() =>
                  this.handleChange(
                    null,
                    selectedContainer.data.backgroundAttachment === "initial" || selectedContainer.data.backgroundAttachment === "unset" || selectedContainer.data.backgroundAttachment === "none"
                      ? "fixed"
                      : "initial",
                    "data.backgroundAttachment"
                  )
                }
                isChecked={selectedContainer.data.backgroundAttachment === "fixed"}
              />
            </Col>
          </Row>
          <Row style={{ marginTop: "0px" }}>
            <Col className="list-setting-item-title">
              <p className="text-muted" style={{ lineHeight: "initial", marginTop: "0px" }}>
                <SystemLabel name="FixatedBackgroundInfo" />
              </p>
            </Col>
          </Row>
          <hr />
          <EditorSlider
            value={selectedContainer.data.style.width !== undefined && selectedContainer.data.style.width !== "unset" ? parseFloat(selectedContainer.data.style.width) : 0}
            defaultValue={0}
            unitChange={this.handleUnitChange}
            attachUnit={true}
            onChange={this.handleChange}
            units={["%", "px"]}
            activeUnit={selectedContainer.data.style.width.toString().replace(/[0-9/^d.-]/g, "") || "%"}
            steps={1}
            max={selectedContainer.data.style.width.toString().replace(/[0-9/^d.-]/g, "") == "%" ? 100 : 1200}
            min={1}
            path={"data.style.width"}
            label="ContainerWidth"
          />
          <hr />
          {selectedContainer.data.style.height !== "auto" ? (
            <React.Fragment>
              <EditorSlider
                value={selectedContainer.data.style.height !== undefined && selectedContainer.data.style.height !== "unset" ? parseInt(selectedContainer.data.style.height) : 200}
                defaultValue={200}
                unitChange={() => null}
                onChange={this.handleChange}
                units={["px"]}
                activeUnit={"px"}
                steps={1}
                max={1000}
                min={80}
                path={"data.style.height"}
                label="ContainerHeight"
              />
              <hr />
            </React.Fragment>
          ) : null}
          <Row>
            <Col className="list-setting-item-title">
              <Label>
                <SystemLabel name="AutoHeight" />
              </Label>
            </Col>
            <Col className="list-setting-item-input" style={{ textAlign: "right" }}>
              <JirangoSwitch
                onChange={() => this.handleChange(null, selectedContainer.data.style.height === "auto" ? 200 : "auto", "data.style.height")}
                isChecked={selectedContainer.data.style.height === "auto"}
              />
            </Col>
          </Row>
        </ListExpansion>
        <br />
        {cms.enviroment === sourceTypes.FORM ? (
          <React.Fragment>
            <ListExpansion footer={false} icon="fa fa-square" description="Conditions">
              <CondtionTypeList
                // onSelect={this.toggleConditionModal}
                element={selectedContainer}
                toggleConditionModal={this.props.toggleConditionModal}
              />
            </ListExpansion>
            <Row>
              <Col
                style={{
                  marginLeft: "22px",
                  marginTop: "5px",
                  fontStyle: "italic",
                }}
                className="list-setting-item-title"
              >
                <p className="text-muted" style={{ lineHeight: "initial" /*  marginTop: "5px" */ }}>
                  <SystemLabel name="CondtionsForContainer" />
                </p>
              </Col>
            </Row>
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { enviroment } = state.cms;
  let selectedContainer = null;
  if (enviroment === sourceTypes.FORM) selectedContainer = state.form.selectedContainer;
  if (enviroment === sourceTypes.PAGE) selectedContainer = state.page.selectedContainer;
  if (enviroment === sourceTypes.TEMPLATE) selectedContainer = state.template.selectedContainer;
  return {
    form: state.form,
    page: state.page,
    template: state.template.template,
    cms: state.cms,
    selectedContainer,
  };
}

export default connect(mapStateToProps)(ContainerSettings);
